module.exports = __webpack_public_path__ + "img/SEJ_Eventos_escanear_blue.e9bcfaa9.svg";